module.exports = __webpack_public_path__ + "assets/img/eebc-ax.svg";